import { AuthorGuidesAndTips } from '@core/content';
import { useLocation } from '@reach/router';
import React, { FC } from 'react';

interface Props {
  author: AuthorGuidesAndTips;
  className?: string;
  link?: boolean;
}

export const PostAuthorLabel: FC<Props> = ({ author, className = '', link = true }) => {
  const location = useLocation();

  return (
    <div className={`font-medium text-sm text-ocean-blue ${className}`}>
      Written by{' '}
      {link ? (
        <a
          href={`${location.pathname}#about-the-author`}
          className="font-bold font-sharp underline text-sm hover:text-accent-orange"
        >
          {author.name}
        </a>
      ) : (
        <span className="font-bold font-sharp underline text-sm hover:text-accent-orange"> {author.name} </span>
      )}
    </div>
  );
};

export default PostAuthorLabel;
